import { createContext } from "react";
// TODO: Figure out how this works, add typing once concept is understood, possibly refactor to localize view
const LanguageContext = createContext<any>("en");

export default LanguageContext;
